import ForceScan from '../pages/ForceScan/ForceScan'
import ManifestInfo from '../pages/ManifestInfo/ManifestInfo'
import MobileApps from '../pages/MobileApps/MobileApps'
import QuantifiedSites from '../pages/QuantifiedSites/QuantifiedSites'
import SiteInfo from '../pages/SiteInfo/SiteInfo'
import UserInfo from '../pages/UserInfo/UserInfo'

export const PageConstants = [
  {
    title: 'Site Info',
    desc: 'Get publisher ID, site ID, and quantification date for a quantified site',
    url: '/site-info',
    component: SiteInfo
  },
  {
    title: 'User Info',
    desc:
      'Get ID, name, user type, created date, authentication page, and associated networks for a user',
    url: '/user-info',
    component: UserInfo
  },
  {
    title: 'Force Scan',
    desc: 'Force quantification of a website using the Publisher Site Scanner',
    url: '/force-scan',
    component: ForceScan
  },
  {
    title: 'Quantified Sites Report',
    desc: 'View p-code and created date for quantified sites',
    url: '/quantified-sites',
    component: QuantifiedSites
  },
  {
    title: 'Mobile Apps Report',
    desc: 'View MAUs, name, p-code, w-unit, API key, and created date for quantified mobile apps',
    url: '/mobile-apps',
    component: MobileApps
  },
  {
    title: 'Manifest Info',
    desc: 'Get information about the live manifest and its files from the Data Layer Service.',
    url: '/manifest-info',
    component: ManifestInfo
  }
]



// WEBPACK FOOTER //
// ./src/constants/page-constants.js